var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreamenterDecreamneter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74436 9.32947H12.2556L8.42982 13.1553C8.31581 13.2693 8.1612 13.3333 8 13.3333C7.83879 13.3333 7.68419 13.2693 7.57018 13.1553L3.74436 9.32947Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74426 6.67045H12.2555L8.42972 2.84463C8.31572 2.73065 8.16111 2.66663 7.99991 2.66663C7.8387 2.66663 7.68409 2.73065 7.57009 2.84463L3.74426 6.67045Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreamenterDecreamneter);
export default __webpack_public_path__ + "static/media/increamenterDecreamneter.ed0e89c308a0237fe409bc2dd6ea5dc1.svg";
export { ForwardRef as ReactComponent };